<template>
  <Page>
    <section class="normalsetting-container">
      <Announce style="margin-top: 8px;" />
      <Breadcrumb 
        title="通用信息" 
        :extraTabs="extraTabList" 
        @extra="extraTabHandle"
      />
      
      <Personal v-if="curExtraTab?.field == 'personal'" />
      <Accounts v-if="curExtraTab?.field == 'accounts'" />
    </section>
  </Page>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import Page from '@/components/page';
  import Announce from '@/components/announce';
  import Breadcrumb from '@/components/breadcrumb';
  import Personal from './components/personal';
  import Accounts from './components/accounts';

  const extraTabList = ref([
    { label: '个人信息', field: 'personal' }, 
    { label: '账号列表', field: 'accounts' }
  ])
  const curExtraTab = ref(null)
  const extraTabHandle = item => {
    curExtraTab.value = item;
    extraTabList.value.map(_item => _item.active = _item.field == item.field)
  }

  onMounted(() => {
    extraTabHandle(extraTabList.value[0])
  })
</script>

<style scoped lang="less">
  @import "./index.less";
</style>